module.exports = __webpack_public_path__ + "img/jp.7760fc8f.svg";